import { useEffect, useState } from 'react'
import './LevelSelection.css'

interface LevelSelectionProps {
  onSelection: (selectionValue: string) => void
  levels: string[][]
}

export default function LevelSelection (props: LevelSelectionProps) {
  const [animationClass, setAnimationClass] = useState('')

  useEffect(() => {
    setTimeout(() => {
      setAnimationClass('animation-level-enter')
    }, 250)
  }, [])
  // For the purposes of this demo, we are defining the levels here
  // but as a component we could pass the levels array in and the component would build the popup
  const optionsList: JSX.Element[] = []
  props.levels.forEach((data, i) => {
    let disabled = true

    if (data[1]) {
      disabled = false
    }

    optionsList.push(
      <button key={i}
              className='btn_list--blue'
              onClick={data[1] ? () => handleLevelSelect(data[1]) : undefined}
              disabled={disabled}>
        <span>{i + 1}</span>{data[0]}
      </button>
    )
  })

  function handleLevelSelect (level: string) {
    setAnimationClass('animation-level-leave')
    props.onSelection(level)
  }

  return (
    <div className={'w-full h-body absolute grid content-center'}>
      <div className={'mx-auto max-w-[334px] opacity-0 ' + animationClass}>
        <p className='text-2xl font-bold text-primary-blue'>
          Upgrade through the levels<br />
          and score points preventing<br />
          hazards in each room.
        </p>

        <div className='mx-auto mt-[60px] text-center border-[12px] border-primary-blue rounded-[24px] relative'>
          <div className='absolute -top-[50px] left-0 right-0 flex justify-center'>
            <img src='/images/clip.svg' alt='' className='' />
          </div>
          <div className='bg-white p-[10px]'>
            {optionsList}
          </div>
        </div>
      </div>
    </div>
  )
}

LevelSelection.defaultProps = {
  levels: [
    ['Broken leg mystery', 'room'],
    ['Bang on the head', 'hall'],
    ['Who\'s the fire', 'kitchen'],
    ['A broken heart', '']
  ]
}
